module.exports = __webpack_public_path__ + "img/family-5.425b755b.jpg";